import { signer } from '#types/loreTypes.tsx'
import { CompletedIconGreen, WaitingIcon } from '../icons'
import TypographyParagraph from '../typography/TypographyParagraph'
import ContentTile from '../content/ContentTile'

export default function SignersTable({ data }: { data: signer[] }) {
	return (
		<>	
			{data && data.length ? (
				<div>
					{data.map((signer: signer, index: number) => (
						<ContentTile
							key={signer.wallet + index.toString()}
							title={signer.username ? signer.username : signer.wallet}
							description={signer.role}
							isVerified={false}
							icon={
								signer.status == 'Pending' ? (
									<WaitingIcon />
								) : (
									<CompletedIconGreen />
								)
							}
							showCaret={true}
							showBorder={false}
							variant="user"
							image={signer.image}
						/>
					))}
				</div>
			) : (
				<div className="mt-12 flex flex-col items-center justify-center">
					<TypographyParagraph
						size="medium"
						additionalClasses="text-textSecondaryLight dark:text-textSecondaryDark"
					>
						No related signers.
					</TypographyParagraph>
				</div>
			)}
		</>
	)
}
